import './FloatingPage.css';
import { QuestionButton } from '../generalComponents/Buttons/QuestionButton';
import React, {useState, useEffect, useRef, useMemo, useCallback} from 'react';
import { fetchInitQuestions } from "../../services/messageService";
import {  useAppContext } from "../../AppDataContext";
import {brandLogo, BZ, closeWidgetBtn, headerLogo, logoBrandImg} from "../../utils";
import { getUserId } from "../../services/authService";
import { initializeWidgetConfig } from "../../utils/widgetConfigInit";

type LanguageKey = string;

interface DebugState {
  is_debug: boolean;
  state_stage: number;
}

interface MessageCaption {
  top: string;
  bottom: bottomLine;
}

interface bottomLine {
  asset: string;
  article: string;
  default: string;
}

interface LanguageConfig {
  poweredBy: string;
  firstTimeButtonCaption: string;
  firstTimeMessage: MessageCaption;
}

interface FloatingConfig {
  [key: LanguageKey]: LanguageConfig;
}

const FloatingPage: React.FC = () => {
  const [previousConfig, setPreviousConfig] = useState<any>(null);
  const floatingConfig: FloatingConfig = require('../../utils/floatingWidgetConfig.json');
  const openState = 4;
  const minimized1State = 0;
  const max_characters_for_questions = 50; //limits the questions to 2 rows in the element
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debug_state: DebugState = { is_debug: false, state_stage: 4 };
  const [currentStateIndex, setCurrentStateIndex] = useState(debug_state.is_debug ? debug_state.state_stage : minimized1State);
  const floatingPageRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [questions, setQuestions] = useState<string[]>([]);
  const [iFrameSrc, setIFrameSrc] = useState('');
  const [isActiveChat, setIsActiveChat] = useState(false);

    //  const [fadeInClass, setFadeInClass] = useState('');
  const [firstTime, setFirstTime] = useState<boolean>(() => {
    const value = localStorage.getItem('FirstTimeMessageClicked');
    return !value;
  });
  let dataContext = useAppContext();
  const languageKey: string = (dataContext.language_for_widget && dataContext.language_for_widget in floatingConfig) ? dataContext.language_for_widget : "EN";
  const states = dataContext.floatingState;
   const [fadeClass, setFadeClass] = useState('fade-out');
 const [isfadeOut, setIsFadeOut] = useState<boolean>(false);
 const isTouch = useRef<boolean>(false);
  const handleFirstMessageButtonClick = () => {
    localStorage.setItem('FirstTimeMessageClicked', 'true');
    setFirstTime(false);
  };


useEffect(() => {
    if (isActiveChat) {
      if(currentStateIndex !== openState) {
        setCurrentStateIndex(openState); // Set to openState directly
      }
    return; // Skip the rest of the effect
  }
  const currentState = states[currentStateIndex];
  const duration = currentState.duration || 1000; // Set a minimum duration of 1000ms for openState
  if(isTouch.current) {return;}
  timerRef.current = setTimeout(() => {

    setCurrentStateIndex((prevIndex) => {
      let nextIndex = (prevIndex + 1) % states.length;
      // console.debug('nextIndex', nextIndex);

      if (nextIndex === openState) {
        nextIndex = (nextIndex + 1) % states.length;
      }
      if (nextIndex === openState) {
        nextIndex = minimized1State;
      }

      return debug_state.is_debug ? debug_state.state_stage : nextIndex;
    });
  }, duration);
  return () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };
}, [currentStateIndex, states, minimized1State, openState, debug_state]);

  const fetchData = async () => {
    const data = await fetchInitQuestions(
      dataContext.proxy,
      dataContext.client_token,
      dataContext.client_id,
      dataContext.userId,
      dataContext.article_index,
      dataContext.language_for_widget,
      dataContext.asset_type,
      dataContext.asset_symbol,
      dataContext.follow_up_questions,
        max_characters_for_questions
    );

    const questionRegex = /<question>(.*?)<\/question>/g;
    const questionsArray: string[] = [];
    let match;
    while ((match = questionRegex.exec(data.text)) !== null) {
      questionsArray.push(match[1]);
    }
    //localStorage.removeItem('FirstTimeMessageClicked');
    setQuestions(questionsArray);
  };

  useEffect(() => {
    if(questions.length === 0 || currentStateIndex === openState - 1)
        fetchData();
  }, [currentStateIndex]);

const handleHover = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
  // console.log('Hover event triggered by:', event.target);

  if (timerRef.current) {
    clearTimeout(timerRef.current);
  }

  setCurrentStateIndex(debug_state.is_debug ? debug_state.state_stage : openState);
}, [debug_state.is_debug, debug_state.state_stage, openState]);

const handleTouch = useCallback(
  (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (isActiveChat) {
      return;
    }
    let currentState = currentStateIndex;
    if (event.target instanceof HTMLElement) {
      const targetClass = event.target.className;
      const parentClass = event.target.parentElement?.className;
            if (targetClass.includes("questionButton__text") || parentClass?.includes("questionButton__text")) {
                const questionText = event.target.textContent || "";
                handleQuestionButtonClick(questionText);
                return;
            }
      if (targetClass.includes("floating__logo") || parentClass?.includes("floating__logo")) {
          isTouch.current = !isTouch.current; // Toggle isTouch state
          if (currentStateIndex !== openState) {
              // First touch: open and cancel timeout
              if (timerRef.current) {
                  clearTimeout(timerRef.current);
              }
              currentState = openState;
          } else {
              // Second touch: minimize and restart timeout
              currentState = minimized1State;

              timerRef.current = setTimeout(() => {
                  setCurrentStateIndex((prevIndex) => {
                      let nextIndex = (prevIndex + 1) % states.length;
                      if (nextIndex === openState) {
                          nextIndex = (nextIndex + 1) % states.length;
                      }
                      if (nextIndex === openState) {
                          nextIndex = minimized1State;
                      }
                      return debug_state.is_debug ? debug_state.state_stage : nextIndex;
                  });
              }, states[minimized1State]?.duration || 1000);
          }
      }
    }
    setCurrentStateIndex(debug_state.is_debug ? debug_state.state_stage : currentState);
  },
  [debug_state.is_debug, debug_state.state_stage, currentStateIndex]
);

const handleClick = useCallback(
  (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // event.stopPropagation();

    if (isActiveChat) {
      return;
    }
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
    setCurrentStateIndex(debug_state.is_debug ? debug_state.state_stage : openState);
  },
  [debug_state.is_debug, debug_state.state_stage, openState]
);


const handleMouseOut = useCallback((event: MouseEvent) => {
    if(isActiveChat){
      return
    }
  // console.log('Mouse out event triggered by:', event.target);
  if (floatingPageRef.current && (!event.relatedTarget || !floatingPageRef.current.contains(event.relatedTarget as Node))) {
    // console.log('Mouse out event is outside the floating page');
    setCurrentStateIndex(debug_state.is_debug ? debug_state.state_stage : minimized1State);
  }
}, [debug_state.is_debug, debug_state.state_stage, minimized1State]);

useEffect(() => {
    if (isActiveChat) {
        return
    }
    const floatingPageElement = floatingPageRef.current;

    if (floatingPageElement) {
        const handleHoverWrapper = (event: Event) =>
            handleHover(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
        const handleClickWrapper = (event: Event) =>
            handleClick(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
        const handleTouchWrapper = (event: Event) =>
            handleTouch(event as unknown as React.TouchEvent<HTMLDivElement>);
        floatingPageElement.addEventListener('mouseover', handleHoverWrapper);
        floatingPageElement.addEventListener('mouseout', handleMouseOut);
        floatingPageElement.addEventListener('click', handleClickWrapper);
        floatingPageElement.addEventListener('touchstart', handleTouchWrapper, {passive: false, once: true});
    }

    const elementsToHover = floatingPageElement?.querySelectorAll(
        '.floatingPage .brandLogo, .questionWrapper, .questionButton__text, .floating__logo'
    );
    // elementsToHover?.forEach(element => {
    //     if (isActiveChat) {
    //         return
    //     }
    //     const handleHoverWrapper = (event: Event) =>
    //         handleHover(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
    //     const handleClickWrapper = (event: Event) =>
    //         handleClick(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
    //     const handleTouchWrapper = (event: Event) =>
    //         handleTouch(event as unknown as React.TouchEvent<HTMLDivElement>);
    //     element.addEventListener('mouseover', handleHoverWrapper);
    //     element.addEventListener('click', handleClickWrapper);
    //     element.addEventListener('touchstart', handleTouchWrapper, {passive: false});
    // });

    return () => {
        if (isActiveChat) {
            return
        }
        if (floatingPageElement) {
            const handleHoverWrapper = (event: Event) =>
                handleHover(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
            const handleClickWrapper = (event: Event) =>
                handleClick(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
            const handleTouchWrapper = (event: Event) =>
                handleTouch(event as unknown as React.TouchEvent<HTMLDivElement>);

            floatingPageElement.removeEventListener('mouseover', handleHoverWrapper);
            floatingPageElement.removeEventListener('mouseout', handleMouseOut);
            floatingPageElement.removeEventListener('click', handleClickWrapper);
            floatingPageElement.removeEventListener('touchstart', handleTouchWrapper);
        }
        elementsToHover?.forEach(element => {
            const handleHoverWrapper = (event: Event) => handleHover(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
            const handleClickWrapper = (event: Event) => handleClick(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
            const handleTouchWrapper = (event: Event) => handleTouch(event as unknown as React.TouchEvent<HTMLDivElement>);
            element.removeEventListener('mouseover', handleHoverWrapper);
            element.removeEventListener('click', handleClickWrapper);
            element.removeEventListener('touchstart', handleTouchWrapper);
        });
    };
}, [handleHover, handleTouch, handleMouseOut, handleClick]);
const chatWidth = useRef<[CSSStyleRule | null, CSSStyleRule | null]>([null, null]);
function getCSSDefinedSize(selector: string): { originalWidth: string | null; originalHeight: string | null } {
    let originalWidth: string | null = null;
    let originalHeight: string | null = null;

    requestAnimationFrame(() => {
        for (const sheet of document.styleSheets) {
            if (sheet.href && !sheet.href.startsWith(window.location.origin)) continue;

            try {
                for (const rule of sheet.cssRules || []) {
                    if (rule instanceof CSSMediaRule) {
                        if (window.matchMedia(rule.conditionText).matches) {
                            for (const subRule of rule.cssRules) {
                                if (subRule instanceof CSSStyleRule && subRule.selectorText === selector) {
                                    originalWidth = subRule.style.getPropertyValue("width") || originalWidth;
                                    originalHeight = subRule.style.getPropertyValue("height") || originalHeight;
                                    // console.debug(subRule, originalWidth, originalHeight);
                                    chatWidth.current[0] = subRule ;
                                     return { originalWidth, originalHeight };
                                }
                            }
                        }
                    } else if (rule instanceof CSSStyleRule && rule.selectorText === selector) {
                        originalWidth = rule.style.getPropertyValue("width") || originalWidth;
                        originalHeight = rule.style.getPropertyValue("height") || originalHeight;
                         // console.debug(rule, originalWidth, originalHeight);
                         chatWidth.current[1] = rule ;
                          return { originalWidth, originalHeight };
                    }
                }
            } catch (e) {
                console.warn("Cannot access stylesheet:", sheet.href, e);
            }
        }
    });

    return { originalWidth, originalHeight };
}



useEffect(() => {
  const getVisibleElements = async () => {
    await new Promise(resolve => setTimeout(resolve, 10)); // Wait for 10 milisecond (adjust as needed)
    let maxWidth = 0;
    let maxHeight = 0;
    let iframeHeight = "";
    let iframeWidth = "";

    const visibleElements = await Promise.all(
      Array.from(document.querySelectorAll("[class^='floating']"))
        .filter((el) => {
          if (!(el instanceof HTMLElement) || el.classList.contains('floatingContainer')) return false;
          const rect = el.getBoundingClientRect();
          const style = window.getComputedStyle(el);
          return (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.bottom > 0 &&
            rect.right > 0 &&
            rect.top < window.innerHeight &&
            rect.left < window.innerWidth &&
            style.display !== "none" &&
            style.visibility !== "hidden" &&
            style.opacity !== "0"
          );
        })
        .map(async (el) => {
          const rect = el.getBoundingClientRect();
          const { originalWidth, originalHeight } = await getCSSDefinedSize(".floatingPage.open.floatingChat");

          // Calculate maxWidth and maxHeight for the entire list
          maxWidth = Math.max(maxWidth, rect.width + 20);
          maxHeight = Math.max(maxHeight, rect.height + 20);

          return {
            tag: el.className,
            width: rect.width,
            height: rect.height,
            classList: [...el.classList].join(" "), // Include class names
            originalWidth,
            originalHeight,
          };
        })
    );

    // Now calculate iframeWidth and iframeHeight
    iframeHeight = !isActiveChat ? `${maxHeight}px` :  'calc(100vh - 20px)';
    iframeWidth = !isActiveChat ? `${maxWidth}px` : `${ chatWidth.current[1]?.style.width || '100vw'}`;
    const iframeMaxWidth = isActiveChat ? chatWidth.current[1]?.style.maxWidth :""
    const iframeMinWidth = isActiveChat ? chatWidth.current[1]?.style.minWidth :""
    // console.clear(); // Clear console before logging
    // console.log("=== Visible Elements ===");
    // console.table(`widthChat::: ${chatWidth.current[1]?.style.width}`)
    // console.table(`maxWidthChat::: ${chatWidth.current[1]?.style.maxWidth}`)
    // console.table(visibleElements); // Nicely formatted table in the console

    // Send max width & height to parent window
    window.parent.postMessage(
      {
        type: "resize",
        size: {
          width: iframeWidth,
          height: iframeHeight,
          maxwidth:iframeMaxWidth,
          minwidth:iframeMinWidth
        },
      },
      "*"
    );
  };

  getVisibleElements(); // Run on mount
  window.addEventListener("resize", getVisibleElements); // Run on resize

  return () => window.removeEventListener("resize", getVisibleElements);
}, [currentStateIndex, isActiveChat]);



useEffect(() => {
  const handleResize = () => {
    if (isActiveChat || window.innerWidth > 600) {
      document.documentElement.style.transform = '';
      document.documentElement.style.transformOrigin = '';
    } else {
      // document.documentElement.style.transform = `scale(${window.innerWidth > 420 ? 0.8 : 0.7})`;
      document.documentElement.style.transformOrigin = 'right bottom';
    }
  };



  window.addEventListener('resize', handleResize);
  handleResize(); // Call once to set initial state

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, [isActiveChat]);

  const { brandImageSrc, headerImageScr, selfLogoImgSrc } = useMemo(() => {
    const client = dataContext.client_id === BZ ? dataContext.client_id:BZ
    return {
      brandImageSrc: dataContext.badgeurl && brandLogo[client as keyof typeof brandLogo]
        ? brandLogo[client as keyof typeof brandLogo]
        : brandLogo.default,
      headerImageScr: dataContext.logourl && headerLogo[client as keyof typeof headerLogo]
        ? headerLogo[client as keyof typeof headerLogo]
        : headerLogo.default,
      selfLogoImgSrc: logoBrandImg
    };
  }, [dataContext.badgeurl, dataContext.logourl]);

function openAppWithParams(params: Record<string, any>) {
  // Remove null and undefined values
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value != null)
  );

  // Handle circular structures safely
  function safeStringify(obj: any) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) return undefined; // Skip circular reference
        seen.add(value);
      }
      return value;
    });
  }

  // Encode each key-value pair safely
  return encodeURIComponent(safeStringify(filteredParams));
}


  // useEffect(() => {
  //   setIsActiveChat(true);
  // }, []);

const handleCloseWidget = () => {
  setIsFadeOut(true);
  setTimeout(() => {
    setIsFadeOut(false);
    setCurrentStateIndex(minimized1State);
    setIsActiveChat(false);
    setPreviousConfig(null);
    isTouch.current = false; // Reset touch state
  }, 400); // Adjust the timeout duration as needed
};

  async function handleQuestionButtonClick(questionText: string) {
    const currentConfig = {
      htmlContent: document.documentElement.innerHTML,
    currentStateIndex,
    dataContext: { ...dataContext }
    };
    setPreviousConfig(currentConfig);
    const questionForChat = questionText.replace(/<color>/g, '').replace(/<\/color>/g, '');
    const root = dataContext.root;
    // setIsFadeOut(true); // Set fade-out to true
    await new Promise(resolve => setTimeout(resolve, 400)); // Wait for 3 seconds (adjust as needed)
    setFadeClass('fade-in');
    const renderApp = async (data: any) => {
      const contextValueIn = {
        userId: data?.userId || dataContext.userId,
        logourl: data?.logo_url || dataContext.logourl,
        badgeurl: data?.badge_url || dataContext.badgeurl,
        error_message: data?.error_message || dataContext.error_message,
        should_present_legal_banner: data?.should_present_legal_banner || dataContext.should_present_legal_banner,
        client_id: data?.client_name || dataContext.client_id,
        client_token: data?.client_token || dataContext.client_token,
        article_index: dataContext.article_index,
        follow_up_question: questionForChat,
        proxy: dataContext.proxy,
        welcome_message: null,
        language_for_widget: null,
        floatingState: data?.floatingState || dataContext.floatingState,
        asset_type: undefined,
        asset_symbol: undefined,
        follow_up_questions: undefined,
        language_for_chat: dataContext.language_for_widget,
        widget_type:dataContext.widget_type,
        root: null
      };

      const { contextValueOut } = await initializeWidgetConfig(contextValueIn);
      const { root = null, floatingState = null, follow_up_questions = null, welcome_message = null, ...set_chat_params } = contextValueOut || {};
      const queryString = openAppWithParams(set_chat_params);
      const host =  window.location.origin;
      if (root) {
         const iframeSrc = `${host}?widget_params=${queryString}`;
         setIFrameSrc(iframeSrc);
        setIsActiveChat(true);
      }
    };

    if (!dataContext.userId || dataContext.userId === "defaultUser") {
      dataContext.userId = await getUserId(dataContext.userId);
    }
    await renderApp(dataContext);
  }
  const floatChatElementName ='floatingChat'
  const poweredByText = floatingConfig[languageKey].poweredBy;
  const poweredByParts = poweredByText.split('{logo}');
  const askText = floatingConfig[languageKey].firstTimeMessage.top;
  const askByParts = askText.split('{logo}');
  return (
      <div className={isfadeOut ? 'fade-out': 'fade-in'} >
    <div ref={floatingPageRef} className={`floatingPage ${states[currentStateIndex].name} ${isActiveChat ? floatChatElementName: ''}`}
         onMouseOver={handleHover} onClick={handleClick} onTouchStart={handleTouch}
    >
      {firstTime && states[currentStateIndex].name === 'open' && (
        <div className={`tipMessage ${states[currentStateIndex].name} firstTime ${isActiveChat ? floatChatElementName: ''}`}
        >
                   <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              gap: "30px",  // Ensures spacing without relying on margin
              flexWrap: "wrap"  // Prevents overflow on smaller screens
            }}>
              {askByParts[0] && (
              <span id="top1PR" style={{ marginRight: "10px", whiteSpace: "nowrap" }}>
                {askByParts[0].trim()}
              </span>
            )}
            <img
              className={`brandHeaderLogo ${states[currentStateIndex].name}`}
              src={headerImageScr}
              style={{
                position: "relative", // Avoids absolute positioning issues
                top: "44px",
                filter: "invert(1) brightness(0) contrast(1)",
                maxWidth: "100%", // Ensures responsiveness
                height: "auto",
                marginTop: "-50px"
              }}
              alt="headerbrand"
            />
            {askByParts[1] && (
              <span id="top2PR" style={{ marginLeft: "10px", whiteSpace: "nowrap" }}>
                {askByParts[1].trim()}
              </span>
            )}
          </div>

        <span id="bottomPR" style={{ textAlign: "center", display: "flex-start", marginTop: "-10px" }}>
          {dataContext.asset_type
            ? floatingConfig[languageKey].firstTimeMessage.bottom.asset
            : dataContext.article_index
            ? floatingConfig[languageKey].firstTimeMessage.bottom.article
            : floatingConfig[languageKey].firstTimeMessage.bottom.default}
        </span>
        <div
          className={`tipMessageButton ${states[currentStateIndex].name} firstTime`}
          onClick={handleFirstMessageButtonClick}
          style={{ margin: "10px auto", textAlign: "center" }}
        >
          <span>{floatingConfig[languageKey].firstTimeButtonCaption}</span>
          </div>
        </div>
      )}
      <div className={`floatingContainer ${states[currentStateIndex].name} ${isActiveChat ? floatChatElementName : ''}`}
           onMouseOver={handleHover} onClick={handleClick} onTouchStart={handleTouch}
          // style={{ transform: `scale(${scale})`,  transformOrigin: 'bottom right' }}
      >
        {/*<img className={`brandHeaderLogo ${states[currentStateIndex].name}`} src={headerImageScr}*/}
        {/*     alt="headerbrand"*/}
        {/*     onMouseOver={handleHover} onClick={handleTouch} />*/}
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
          width: "100%",
          flexDirection: "row"
        }}>
          <img
              className={`brandHeaderLogo ${states[currentStateIndex].name} ${isActiveChat ? floatChatElementName : ''}`}
              src={headerImageScr}
              alt="headerbrand"
          />
          <img className="closeWidget" onClick={e => { e.stopPropagation(); handleCloseWidget(); }} src={closeWidgetBtn} alt="Close"
               {...(!isActiveChat && {style: {display: "none"}})}/>
        </div>
        <img className={`brandLogo ${states[currentStateIndex].name}`} src={brandImageSrc} alt="brand"
             onMouseOver={handleHover} onClick={handleClick} onTouchStart={handleTouch}/>
        <>
          {isActiveChat ? (
              // eslint-disable-next-line jsx-a11y/iframe-has-title
              <iframe className="iframeChat" style={{transform: 'scale(1)', transformOrigin: 'bottom right'}}
                      src={iFrameSrc}></iframe>
          ) : (
              questions.map((question, index) => (
                  <div key={index} className={`questionWrapper ${states[currentStateIndex].name}`}
                       onMouseOver={handleHover} onClick={handleClick} onTouchStart={handleTouch}>
                    <QuestionButton
                        color={"rgba(0, 110, 168, 1)"}
                        fontWeight={"bold"}
                        listText={""}
                        questionText={question}
                        floatingWidgetState={states[currentStateIndex].name + (firstTime ? " firstTime" : "")}
                        buttonHandler={handleQuestionButtonClick}
                        isPress={false}
                        load={false}
                    />
                  </div>
              ))
          )}
        </>
      </div>
      <div className={`floating__logo ${states[currentStateIndex].name} ${isActiveChat ? ' floatingChat' : ''}`}
           onMouseOver={handleHover} onClick={handleClick} onTouchStart={handleTouch}><span>AI</span>
        </div>
        <div style={{display: "flex", alignItems: "center", gap: "10px", bottom: 0, right: 0}}>
           <a href="https://wnstn.ai/" target="_blank" rel="noopener noreferrer" style={{display: "flex", alignItems: "center", gap: "10px"}}>
          {poweredByParts[0] && <span style={{right: "50%"}}
                                      className={`poweredBy ${states[currentStateIndex].name}`}>{poweredByParts[0].trim()}</span>}
          <img style={poweredByParts[0].trim().length > 0 ? {left: "50%"} : {right: "50%"}}
               className={`selfLogo ${states[currentStateIndex].name}`} src={selfLogoImgSrc}
               alt="selfLogo"/>
          {poweredByParts[1] && <span style={{left: "50%", marginLeft: "5px"}}
                                      className={`poweredBy ${states[currentStateIndex].name}`}>{poweredByParts[1].trim()}</span>}
           </a>
           </div>
      </div>
    </div>
        );
        };

        export default FloatingPage;

